class SiteSearch {
    constructor() {
        // define icons
        const allIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="36" viewBox="0 0 40 36"> <g id="Group_43" data-name="Group 43" transform="translate(-980 -244)"> <rect id="Rectangle_58" data-name="Rectangle 58" width="28" height="2" transform="translate(992 248)"/> <rect id="Rectangle_59" data-name="Rectangle 59" width="12" height="2" transform="translate(992 244)"/> <rect id="Rectangle_60" data-name="Rectangle 60" width="6" height="6" transform="translate(980 244)"/> <rect id="Rectangle_61" data-name="Rectangle 61" width="28" height="2" transform="translate(992 258)"/> <rect id="Rectangle_62" data-name="Rectangle 62" width="12" height="2" transform="translate(992 254)"/> <rect id="Rectangle_63" data-name="Rectangle 63" width="6" height="6" transform="translate(980 254)"/> <rect id="Rectangle_64" data-name="Rectangle 64" width="28" height="2" transform="translate(992 268)"/> <rect id="Rectangle_65" data-name="Rectangle 65" width="12" height="2" transform="translate(992 264)"/> <rect id="Rectangle_66" data-name="Rectangle 66" width="6" height="6" transform="translate(980 264)"/> <rect id="Rectangle_67" data-name="Rectangle 67" width="28" height="2" transform="translate(992 278)"/> <rect id="Rectangle_68" data-name="Rectangle 68" width="12" height="2" transform="translate(992 274)"/> <rect id="Rectangle_69" data-name="Rectangle 69" width="6" height="6" transform="translate(980 274)"/> </g></svg>';
        const pageIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="40" viewBox="0 0 36 40"> <g id="Group_48" data-name="Group 48" transform="translate(-790 -300)"> <path id="Path_18" data-name="Path 18" d="M822,308v-4h-4v-4H790v32h4v4h4v4h28V308Zm-30,22V302h2v2h4v-2h18v28h-2v-8h-8v8H792Zm4,4v-2h22V306h2v28H796Zm28,4H800v-2h22V310h2Z"/> <rect id="Rectangle_70" data-name="Rectangle 70" width="20" height="10" transform="translate(794 310)"/> <rect id="Rectangle_71" data-name="Rectangle 71" width="10" height="2" transform="translate(794 306)"/> <rect id="Rectangle_72" data-name="Rectangle 72" width="10" height="2" transform="translate(794 322)"/> <rect id="Rectangle_73" data-name="Rectangle 73" width="10" height="2" transform="translate(794 326)"/> </g></svg>';
        const newsIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="36" viewBox="0 0 40 36"> <g id="Group_39" data-name="Group 39" transform="translate(-850 -242)"> <path id="Path_16" data-name="Path 16" d="M882,248v-6H850v36h32l2-2,6-28Zm-2,28H852V244h28Z"/> <rect id="Rectangle_47" data-name="Rectangle 47" width="12" height="12" transform="translate(854 246)"/> <rect id="Rectangle_48" data-name="Rectangle 48" width="16" height="2" transform="translate(854 272)"/> <rect id="Rectangle_49" data-name="Rectangle 49" width="24" height="2" transform="translate(854 268)"/> <rect id="Rectangle_50" data-name="Rectangle 50" width="24" height="2" transform="translate(854 264)"/> <rect id="Rectangle_51" data-name="Rectangle 51" width="24" height="2" transform="translate(854 260)"/> <rect id="Rectangle_52" data-name="Rectangle 52" width="10" height="2" transform="translate(868 256)"/> <rect id="Rectangle_53" data-name="Rectangle 53" width="10" height="2" transform="translate(868 252)"/> <rect id="Rectangle_54" data-name="Rectangle 54" width="10" height="4" transform="translate(868 246)"/> </g></svg>';
        const portIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="34" height="40" viewBox="0 0 34 40"> <g id="Group_37" data-name="Group 37" transform="translate(-790 -240)"> <path id="Path_15" data-name="Path 15" d="M816,270V240H792v30h-2v10h4V242h20v38h10V270Z"/> <rect id="Rectangle_38" data-name="Rectangle 38" width="16" height="2" transform="translate(796 268)"/> <rect id="Rectangle_39" data-name="Rectangle 39" width="16" height="2" transform="translate(796 272)"/> <rect id="Rectangle_40" data-name="Rectangle 40" width="16" height="2" transform="translate(796 264)"/> <rect id="Rectangle_41" data-name="Rectangle 41" width="16" height="2" transform="translate(796 260)"/> <rect id="Rectangle_42" data-name="Rectangle 42" width="16" height="2" transform="translate(796 256)"/> <rect id="Rectangle_43" data-name="Rectangle 43" width="16" height="2" transform="translate(796 252)"/> <rect id="Rectangle_44" data-name="Rectangle 44" width="16" height="2" transform="translate(796 248)"/> <rect id="Rectangle_45" data-name="Rectangle 45" width="16" height="2" transform="translate(796 244)"/> <rect id="Rectangle_46" data-name="Rectangle 46" width="4" height="2" transform="translate(802 278)"/> </g></svg>';
        // toggling header search area
        $('.header__search__icon').off('click').on('click',function(){
            if ($('.header__search').hasClass('active')) {
                $('.header__search').removeClass('active');
            } else {
                $('.header__search').addClass('active');
                $('.header__search input').focus();
            }
        });
        // inputting on header search input
        let headDelay;

        $('.header__search__input input').off('input keydown').val('').on('input keydown',function(e){
            console.log('other');

            const val = $(this).val();
            const prev_val = $(this).data('prev-val');
            if (e.which != 13) {  
                const resultCont = $('.header__search__results');              
                if (val != '') {
                    $('.header__search__go').attr('href','/?s='+val);
                    $('.header__search').addClass('filled');
                    if (val != prev_val) {
                        $(this).data('prev-val',val);
                        const nonce = $(this).data('nonce');
                        clearTimeout(headDelay);                        
                        headDelay = setTimeout(function(){
                            headerSearch(val,resultCont,nonce);
                        },250);
                    }
                } else {
                    $('.header__search').removeClass('filled');
                    resultCont.stop().slideUp(function(){
                        $(this).attr('style','display: none;');
                    });
                }
            } else {
                // special case for hitting Enter
                window.location.href = window.location.protocol + "//" + window.location.hostname + (isFR() ? '/fr/' : '') + "?s="+val;
            }
        });

        //news page filter search
        $('.news-page__filter__text input').off('input keydown').val('').on('input keydown',function(e){
            console.log('sup');

            const val = $(this).val();
            const prev_val = $(this).data('prev-val');
            if (e.which != 13) {  
                const resultCont = $('.header__search__results');              
                if (val != '') {
                    $('.header__search__go').attr('href','/?s='+val);
                    $('.header__search').addClass('filled');
                    if (val != prev_val) {
                        $(this).data('prev-val',val);
                        const nonce = $(this).data('nonce');
                        clearTimeout(headDelay);                        
                        headDelay = setTimeout(function(){
                            headerSearch(val,resultCont,nonce);
                        },250);
                    }
                } else {
                    $('.header__search').removeClass('filled');
                    resultCont.stop().slideUp(function(){
                        $(this).attr('style','display: none;');
                    });
                }
            } else {
                // special case for hitting Enter
                window.location.href = window.location.protocol + "//" + window.location.hostname + (isFR() ? '/fr/' : '') + "?s="+val;
            }
        });

        function headerSearch(val,resultCont,nonce) {
            var data = {
                'nonce': nonce,
                'action': 'header_search',
                'term': val,
                'lang': isFR() ? 'fr' : 'en'
            };
            console.log('searching for '+val,data);
            resultCont.html('<span class="rio-loader"><span></span><span></span><span></span></span>');

            $.post(BJZM_DATA.ajaxurl, data, function(response) {
                resultCont.empty();
                if (response.charAt(0) == '<') {                    
                    resultCont.html(response);
                } else if (response == '') {
                    resultCont.html(isFR() ? 'Rien trouvé' : 'Nothing found!');
                } else {                    
                    const posts = JSON.parse(response);                    
                    if (posts.length) {                                
                        $.each(posts,function(index,item){
                            loadItem(item,resultCont,'head');
                        });
                        if (posts.length > 6) {
                            resultCont.append('<a href="/?s='+val+'" class="more">'+(isFR() ? 'Plus' : 'More')+' <i class="fa fa-chevron-right"></i></a>');
                        }
                    } else {
                        resultCont.html(isFR() ? 'Rien trouvé' : 'Nothing found!');
                    }
                }
            });
            resultCont.stop().slideDown(function(){
                $(this).attr('style','display: block;');
            });
        }
        let pageDelay;
        // inputting on search page input
        $('.rio-search input').off('input keydown').on('input keydown',function(e){
            const val = $(this).val();
            const prev_val = $(this).data('prev-val');              
            if (val != '') {
                if (val != prev_val) {
                    $(this).data('prev-val',val);
                    const nonce = $(this).data('nonce');
                    const resultCont = $('.rio-search__results');
                    clearTimeout(pageDelay);                        
                    pageDelay = setTimeout(function(){
                        pageSearch(val,resultCont,nonce);
                    },250);
                }
            } 
        });
        function pageSearch(val,resultCont,nonce) {
            var data = {
                'nonce': nonce,
                'action': 'page_search',
                'term': val,
                'lang': isFR() ? 'fr' : 'en'
            };
            resultCont.html('<span class="rio-loader"><span></span><span></span><span></span></span>');
            $('.rio-search__dym').remove();
            $.post(BJZM_DATA.ajaxurl, data, function(response) {
                if (response.charAt(0) == '[') {
                    const posts = JSON.parse(response);
                    resultCont.empty();
                    if (posts.length) {                                
                        $.each(posts,function(index,item){
                            loadItem(item,resultCont,'page');
                        });
                        $('.rio-search__filter__item.active').trigger('click');
                    } else {
                        resultCont.html(isFR() ? 'Rien trouvé' : 'Nothing found!');
                    }                    
                } else {
                    resultCont.html(isFR() ? 'Rien trouvé' : 'Nothing found!');
                    $('.rio-search__left').append(response)
                }
            });
            resultCont.stop().slideDown();
        }
        function loadItem(item,resultCont,context) {
            let link = item.guid;
            let type = item.post_type;   
            let image = pageIcon;   
            let title = item.post_title;
            let extra = context == 'head' ? '<i class="fa fa-chevron-right"></i>' : '';
            if (title.length > 55) { title = title.slice(0,55)+'...'; } 
            if (type == 'news_post') { type = 'news'; image = newsIcon; }  
            if (type == 'property') { type = 'portfolio'; image = portIcon; }
            if (isFR()) {
                if (type == 'news') { type = 'nouvelles'; }
                if (type == 'portfolio') { type = 'portefeuille'; }
            }
            resultCont.append('<a href="'+link+'" data-type="'+type+'">'+image+'<span>'+type+'</span>'+title+extra+'</a>');
        }
        // using search page filters
        $('.rio-search__filter__item').on('click',function(){
            $(this).addClass('active').siblings().removeClass('active');
            const filterType = $(this).data('type');
            const items = $('.rio-search__results > a');
            if (filterType == 'all') {
                items.show('fast');
            } else {
                items.hide('fast').filter('[data-type="'+filterType+'"]').show('fast');
            }            
        });
        function isFR() {
            return window.location.pathname.includes('/fr/');
        }
    }
}

module.exports = SiteSearch;